import React, { useEffect, useState } from "react";
import { Info, Smartphone, Monitor } from "lucide-react";
import CheckUpdateButton from "@/components/CheckUpdateButton";
import { getInstalledVersion, WEB_APP_VERSION } from "@/lib/appVersion";
import { apiUrl } from "@/lib/api";
import { getDeviceRole, setDeviceRole } from "@/lib/deviceRole";
import { getLanInfo, isNativePrint } from "@/lib/printTransport";

export default function SystemInfo() {
  const [version, setVersion] = useState(WEB_APP_VERSION);
  const [role, setRole] = useState(() => getDeviceRole());
  const [lan, setLan] = useState(null);

  useEffect(() => {
    getInstalledVersion().then(setVersion).catch(() => {});
    isNativePrint().then((n) => { if (n) getLanInfo().then(setLan).catch(() => {}); });
  }, []);

  const pickRole = (r) => {
    setDeviceRole(r);
    setRole(getDeviceRole());
    window.location.assign(r === "palmare" ? "/palmare" : r === "cassa" ? "/cassa" : "/dashboard");
  };

  return (
    <div className="p-8 lg:p-12 max-w-2xl">
      <div className="text-xs font-mono uppercase tracking-[0.25em] text-velta-mute mb-3">Impostazioni</div>
      <h1 className="font-heading text-4xl font-bold tracking-tight flex items-center gap-3">
        <Info className="w-9 h-9" /> Informazioni sistema
      </h1>
      <p className="text-velta-mute mt-2 mb-8">Versione installata sul tablet e aggiornamenti APK.</p>

      <div className="bg-white border border-velta-border rounded-md p-6 space-y-4 mb-6">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-velta-mute">Applicazione</div>
          <div className="font-heading text-xl font-semibold">Velta One</div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-velta-mute">Versione corrente</div>
          <div className="font-mono text-lg" data-testid="system-app-version">v{version}</div>
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-widest text-velta-mute">API</div>
          <div className="font-mono text-xs break-all text-velta-mute">{apiUrl("/")}</div>
        </div>
        {lan && (
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-velta-mute">Rete di questo tablet</div>
            <div className="font-mono text-sm" data-testid="system-lan-info">
              {lan.ssid ? `Wi‑Fi: ${lan.ssid}` : "Wi‑Fi"} · IP {lan.ip || lan.ips || "—"}
            </div>
            <p className="text-xs text-velta-mute mt-1">
              Il PC cassa è su SSID «Velta Sistemi» con IP 192.168.1.21. Stampanti: 192.168.1.23 (fiscale) e 192.168.1.188 (preconto).
              {String(lan.ip || "").startsWith("192.168.1.")
                ? " Questo tablet è sulla stessa LAN."
                : " Se non vedi 192.168.1.x: collega il tablet alla stessa Wi‑Fi e spegni i dati mobili."}
            </p>
          </div>
        )}
      </div>

      <a
        href="http://2.29.16.27/apk.html"
        data-testid="apk-direct-download"
        className="mb-4 h-12 px-5 bg-[#1E2D5B] hover:bg-[#162244] text-white rounded-md font-medium inline-flex items-center justify-center gap-2 btn-tactile"
      >
        <Smartphone className="w-5 h-5" /> Scarica APK tablet
      </a>
      <p className="text-sm text-velta-mute mb-6">
        Stesso file: <span className="font-mono text-xs break-all">http://2.29.16.27/apk.html</span>
      </p>

      <CheckUpdateButton />

      <div className="bg-white border border-velta-border rounded-md p-6 mt-6" data-testid="device-role-panel">
        <div className="text-[10px] font-mono uppercase tracking-widest text-velta-mute mb-2">App unica Android</div>
        <h2 className="font-heading text-lg font-semibold mb-1">Modalità di questo dispositivo</h2>
        <p className="text-sm text-velta-mute mb-4">Stesso APK: cassa fissa o palmare sala. All&apos;avvio l&apos;app chiede se c&apos;è una versione nuova e la scarica da internet (il cliente distante non deve venire in sede).</p>
        <div className="grid grid-cols-2 gap-2">
          <button type="button" data-testid="device-role-cassa" onClick={() => pickRole("cassa")} className={`h-20 rounded-md border-2 font-medium ${role === "cassa" ? "border-velta-ink bg-velta-ink text-white" : "border-velta-border bg-white"}`}>
            <Monitor className="w-5 h-5 mx-auto mb-1" /> Postazione Cassa
          </button>
          <button type="button" data-testid="device-role-palmare" onClick={() => pickRole("palmare")} className={`h-20 rounded-md border-2 font-medium ${role === "palmare" ? "border-velta-ink bg-velta-ink text-white" : "border-velta-border bg-white"}`}>
            <Smartphone className="w-5 h-5 mx-auto mb-1" /> Palmare Sala
          </button>
        </div>
      </div>
    </div>
  );
}
